import { defineComponent as c, computed as a, createElementBlock as s, createBlock as m, createCommentVNode as d, openBlock as o, toDisplayString as f, unref as p } from "vue";
import { ScalarCodeBlock as v } from "@scalar/components";
import { isDefined as y } from "@scalar/oas-utils/helpers";
import { encode as g } from "js-base64";
import { getHarRequest as x } from "./helpers/get-har-request.js";
import { getSnippet as k } from "./helpers/get-snippet.js";
const S = {
  key: 0,
  class: "text-c-3 flex min-h-16 items-center justify-center px-4 text-sm"
}, N = /* @__PURE__ */ c({
  __name: "CodeSnippet",
  props: {
    target: {},
    client: {},
    operation: {},
    server: {},
    example: {},
    securitySchemes: { default: () => [] },
    environment: {}
  },
  setup(t) {
    const i = a(
      () => t.securitySchemes.flatMap((e) => e.type === "apiKey" ? e.value : (e == null ? void 0 : e.type) === "http" ? [
        e.token,
        e.password,
        g(`${e.username}:${e.password}`)
      ] : e.type === "oauth2" ? Object.values(e.flows).map((r) => r == null ? void 0 : r.token).filter(y) : [])
    ), n = a(() => {
      const e = x({
        operation: t.operation,
        example: t.example,
        server: t.server,
        securitySchemes: t.securitySchemes,
        environment: t.environment
      }), [r, u] = k(t.target, t.client, e);
      return { error: r, payload: u };
    }), l = a(() => t.target === "shell" && t.client === "curl" ? "curl" : t.target ?? "plaintext");
    return (e, r) => n.value.error ? (o(), s("div", S, f(n.value.error.message), 1)) : n.value.payload ? (o(), m(p(v), {
      key: 1,
      class: "w-full",
      content: n.value.payload,
      hideCredentials: i.value,
      lang: l.value,
      lineNumbers: ""
    }, null, 8, ["content", "hideCredentials", "lang"])) : d("", !0);
  }
});
export {
  N as default
};
